import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WgTicketsComponent } from './wg-tickets.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgChartsModule } from 'ng2-charts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FuseWidgetModule } from '@fuse/components';
import { MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
  declarations: [WgTicketsComponent],
  imports: [
    CommonModule,
    FuseSharedModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatProgressSpinnerModule,
    NgChartsModule,
    NgxChartsModule,
    FuseWidgetModule,
    MatTooltipModule
  ],
  exports: [WgTicketsComponent]
})
export class WgTicketsModule { }
